module.exports = __webpack_public_path__ + "static/ic_Foodlogo-6e55ea88f65dcf0b0796a4df0db000c9.svg";